module.exports = __webpack_public_path__ + "static/media/tiempos-text-web-bold.2cd1361c.woff";